<template>
  <pt-batch-grant class="pt-batch-grant__page" :recordMessage="recordMessage"></pt-batch-grant>
</template>

<script>
import PtBatchGrant from 'cps/mall-manage/pt-old-to-new/pt-batch-grant/withData'
export default {
  name: 'pt-batch-grant__view',
  components: {
    'pt-batch-grant': PtBatchGrant
  },
  props: {
    recordMessage: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
